const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-assets/shared/normalization/data-management/ChannelsManagement/utils");